// useLanguage — read/set the active app language from anywhere.
// Returns { language, setLanguage, languages }. Backed by LanguageContext (which
// wraps i18next), so changing the language re-renders all useTranslation() consumers
// in real time. The Footer language selector is the primary caller.
import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within <LanguageProvider>');
  return ctx;
}

export default useLanguage;
